import React from "react";
import {Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import PaymentFileUploader from "./PaymentFileUploader";
import {usePolicyContext} from "./PolicyContext";
import PaymentFileViewer from "./PaymentFileViewer";
import {useFormikContext} from "formik";
import {ErrorCommon} from "../../formikFormInputs";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";

function UploadVoidedCheck() {
    const profile = useSelector((state: RootState) => state.profile);
    const fileType = "image/jpg, image/jpeg, image/png, application/pdf";
    const {policy} = usePolicyContext();
    const {values, setFieldValue, errors, touched}: any = useFormikContext();
    const clientPolicy = profile.client && profile.client.clientPolicies && profile.client.clientPolicies.length > 0 && profile.client.clientPolicies[0];
    const policyNumber = policy && policy.policyNumber || clientPolicy && clientPolicy.id;
    const setFrontPath = (filePath: string) => {
        setFieldValue('checkFrontPath', filePath);
    };

    return (
            <>
                <Grid item xs={12}>
                    <Typography variant="body1" component="strong" className="floatLeft w100 mb0">
                        Upload Voided Check
                    </Typography>
                    <Typography variant="caption" className="floatLeft w100 mb0">
                        The policy holder must be a signor on the account. Only personal accounts are acceptable. No
                        business accounts will be accepted.
                    </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                    {
                            !values.checkFrontPath && <>
                                <PaymentFileUploader
                                        isSecuredSignedUrl={true}
                                        fileType={fileType}
                                        dirName={policyNumber}
                                        fileName={"FrontOfCheck"}
                                        setFileName={setFrontPath}
                                        title="Upload check front"
                                />
                                <ErrorCommon
                                        errors={errors}
                                        name={"checkFrontPath"}
                                        touched={touched}
                                />
                            </>
                    }
                    {
                            values.checkFrontPath &&
                            <PaymentFileViewer
                                    fileName={values.checkFrontPath}
                                    policyNumber={policyNumber}
                                    title={"Front of Check"}
                                    readOnly={false}
                                    deleteFile={() => {
                                        setFrontPath('');
                                    }}
                            />
                    }
                </Grid>
            </>
    );
}

export default UploadVoidedCheck;